module.exports = __webpack_public_path__ + "static/img/ecode.6890a427.jpg";